import { useController, useFormContext } from "react-hook-form";
import { TextField, InputAdornment } from "@mui/material";
import PropTypes from "prop-types";

/**
 * A number input component integrated with react-hook-form.
 * Handles numeric values with optional unit display (e.g., € or kWh).
 */
const FormNumberField = ({ name, unit, ...otherProps }) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const { value, onChange, ...fieldProps } = field;

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === "" || inputValue === null) {
      onChange(null);
    } else {
      const numValue = parseFloat(inputValue);
      onChange(isNaN(numValue) ? null : numValue);
    }
  };

  return (
    <TextField
      {...fieldProps}
      type="number"
      value={value ?? ""}
      onChange={handleChange}
      {...otherProps}
      error={!!error}
      helperText={error?.message || otherProps.helperText}
      slotProps={{
        htmlInput: {
          style: { textAlign: "right", paddingLeft: "10px" },
        },
        input: unit
          ? {
              endAdornment: (
                <InputAdornment position="end">{unit}</InputAdornment>
              ),
            }
          : undefined,
      }}
    />
  );
};

FormNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  unit: PropTypes.string,
};

export default FormNumberField;
